import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeIn from '@angular/common/locales/en-IN';
import localeGB from '@angular/common/locales/en-GB'

registerLocaleData(localeIn)
registerLocaleData(localeGB)

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
